import { Grid } from '@material-ui/core';
import { Button, Tooltip, Icon, DatePicker } from 'antd';
import TextEvents from 'app/components/TextEvents';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../DailyComplianceScreenStyles';
import * as DailyComplianceActions from "app/actions/DailyComplianceActions";

const DailyComplianceFilterComponent = (props) => {
    const classes = useStyles();
    const [collapse, setCollapse] = useState(false);
    const [complianceDate, setComplianceDate] = useState('')
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)

    const {
        isLoadExport,
        pagination
    } = useSelector(state => state.DailyComplianceReducer);

    const data = {
        complianceDate: complianceDate,
        offset: 0,
        limit: pagination.pageSize,
        sortColumn: pagination.column,
        sortDir: pagination.order,
    }

    const search = () => {
        //DailyComplianceActions.saveFilter({complianceDate});
        dispatch(DailyComplianceActions.fetchDailyCompliance(data));
    }

    const exportXls = () => {
        dispatch(DailyComplianceActions.exportXls(data))
    }

    return (
        <div>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6} >
                        <TextEvents
                            text='Fecha:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <DatePicker
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            placeholder='Selecciona Fecha'
                            format={'DD/MM/YYYY'}
                            onChange={(date, dateString) => {
                                const cDate = dateString !== "" ? dateString.split('/').reverse().join('/') : '';
                                dispatch(DailyComplianceActions.saveFilter({complianceDate: cDate}));
                                setComplianceDate(cDate);
                            }}

                        />
                    </Grid>
                </Grid>
            </div>
            {/**Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                    disabled={!complianceDate}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    loading={isLoadExport}
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                    disabled={!complianceDate}
                >
                    Exportar
                </Button>
            </div>
        </div>
    );
}

export default DailyComplianceFilterComponent;
